<template>
  <v-container fluid class="py-0">
    <v-row justify="center">
      <v-col cols="12" md="10" mx-auto>
        <v-container v-if="lAction === 'update-self'" class="pa-0" grid-list-md fluid full-height>
          <v-form ref="lForm" id="form" @submit.prevent="saveChanges(lAction)">
            <v-card flat>
              <v-card-title class="px-0 py-2">
                <v-layout>
                  <v-flex xs12 class="text-center">
                    {{lUser.user_name + ' (' + lUser.role_name + ')'}}
                  </v-flex>
                </v-layout>
              </v-card-title>
              <v-card-text class="px-0 py-3">
                <v-layout row wrap>
                  <v-flex xs12 class="text-center">
                    <v-avatar :size="120" class="grey lighten-4 mb-2">
                      <img v-if="avatarURL" :src="avatarURL">
                      <v-icon color="grey" size="110px" v-else>mdi-account</v-icon>
                    </v-avatar>
                    <br />
                    <input style="display:none" type="file" ref="fileInput"
                    accept="image/*" @change="loadAvatarFromFile"/>
                    <v-btn outlined icon @click="pickAvatar"><v-icon>mdi-pencil</v-icon></v-btn>
                    <v-btn class="ml-2" outlined icon @click="prepareCamera"><v-icon>mdi-camera</v-icon></v-btn>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                    v-model="lUser.emp_phone"
                    label="Mobile Number"
                    :rules="[rules.required]"
                    hide-details
                    maxlength="15"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                    v-model="lUser.emp_email"
                    label="E-Mail"
                    :rules="[rules.required]"
                    hide-details
                    maxlength="50"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-select
                    v-model="lUser.pwd_hint_id"
                    label="Password Hint Question"
                    :items="pwdHintList"
                    item-text="pwd_hint_quest"
                    item-value="pwd_hint_id"
                    :rules="[rules.required]"
                    hide-details
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                    v-model="lUser.pwd_hint_ans"
                    label="Password Hint Answer"
                    :rules="[rules.required]"
                    hide-details
                    maxlength="50"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 class="pt-5">
                    <v-select
                    v-model="lUser.screen_id_list"
                    label="Preferred Dashboard Screens"
                    :items="dashScreenList"
                    item-text="screen_name"
                    item-value="screen_id"
                    multiple
                    small-chips
                    outlined
                    hide-details
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.stop="cancelChanges">Close</v-btn>
                <v-btn type="submit" color="accent" :disabled="beingSaved">save</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-container>

        <v-dialog v-model="vdoDlg" max-width="310px">
          <v-layout row wrap>
            <v-flex xs12>
              <v-card>
                <v-card-text class="pb-2">
                  <video id="cam" style="width:290px; height:200px" autoplay></video>
                </v-card-text>
                <div class="text-center pb-3 pt-0">
                  <v-btn icon @click="capturePhoto"><v-icon x-large>mdi-camera-iris</v-icon></v-btn>
                </div>
                <div style="position:absolute; top:20px; right:20px">
                  <v-btn class="grey darken-1" small icon @click.stop="closeVdoDlg"><v-icon class="black--text">mdi-close</v-icon></v-btn>
                </div>
              </v-card>
            </v-flex>
          </v-layout>
        </v-dialog>
      </v-col>
    </v-row>
    <!-- snack bar for reporting -->
    <v-snackbar :color="sbarCol" v-model="sbar"
    :timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
  </v-snackbar>
</v-container>
</template>

<script>
import VDownloadAs from '@/components/VDownloadAs.vue'
import handy from '@/utils/handy'
import config from '@/config/app-cfg'


export default {
  components:
  {
    'v-download-as': VDownloadAs
  },
  data () {
    return {
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      config: config,
      handy: handy,
      rules: handy.rules,
      beingSaved: false,
      lAction: 'update-self',
      lUser: {},
      pwdHintList: [],
      dashScreenList: [],
      vdoDlg: false,
      avatarURL: !config.AVATAR_URL.includes('base64') ? handy.loadImg(config.AVATAR_URL) : config.AVATAR_URL // image from db or recently changed cache
    }
  },
  created () {
    this.loadUser()
    this.loadPwdHintQuest()
    this.loadDashScreens()
  },
  mounted () {

  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    saveChanges (action) {
      if (!this.$refs.lForm.validate()) {
        return
      } else if (action === 'password-reset' && this.lUser.user_pwd !== this.lUser.retype_pwd) {
        this.msg('Re-typed password does not match with password')
        return
      }
      // proceed with changes
      this.beingSaved = true
      this.lUser.avatar_url = this.avatarURL
      this.axios.post(config.API_URL + '/user/' + action, this.lUser)
      .then(response => {
        // update the object in front end
        if (action !== 'password-reset') {
          config.AVATAR_URL = this.avatarURL
        } else {
          this.lAction = 'update-self'
        }
        this.beingSaved = false
        this.msg('Saved successfully', 1)
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    },
    cancelChanges () {
      this.lAction = 'update-self'
    },
    loadUser () {
      var qry = {
        params: {
          user_id: config.SV_USER_ID
        }
      }
      this.axios.get(config.API_URL + '/getUserByID/', qry)
      .then(response => {
        this.lUser = response.data[0]
        this.lUser.screen_id_list = this.lUser.dashboard_screen_ids ? this.lUser.dashboard_screen_ids.split(',').map(Number) : []
      })
      .catch(err => {
        this.msg(err.response.data)
        this.lUser = {}
      })
    },
    loadPwdHintQuest () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getUserPwdHintQuestByVendorId/', qry)
      .then(response => {
        this.pwdHintList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
        this.pwdHintList = []
      })
    },
    loadDashScreens () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getMenuByRoleId/' + config.ROLE_ID)
      .then(response => {
        // load available screens
        var curItem, curChild, curSubScr
        var rtArray = []
        var tmpComp
        for (var i = 0; i < response.data.length; i++) {
          curItem = response.data[i]
          // menu items
          if (!curItem.children.length) {
            this.dashScreenList.push({screen_id: curItem.screen_id, screen_name: curItem.text})
          } else {
            // sub menu items
            for (var j = 0; j < curItem.children.length; j++) {
              curChild = curItem.children[j]
              if (!curChild.subscreens.length) {
                this.dashScreenList.push({screen_id: curChild.screen_id, screen_name: (curItem.text + ' > ' + curChild.text)})
              } else { // sub menus with another level sub screens
                for (var k = 0; k < curChild.subscreens.length; k++) {
                  curSubScr = curChild.subscreens[k]
                  this.dashScreenList.push({screen_id: curSubScr.screen_id, screen_name: (curItem.text + ' > ' + curChild.text + ' > ' + curSubScr.text)})
                } // each subscr
              } // subscr
            } // each submenu
          } // submenu
        } // each menu
      })
      .catch(err => {
        this.msg(err.response.data)
        this.dashScreenList = []
      })
    },
    prepareCamera () {
      if (!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) {
        alert('Sorry, your browser does not support this feature\nTry using google chrome')
        return
      }

      // start camera and play
      navigator.mediaDevices.getUserMedia({video: true})
      .then(stream => { // success
        this.vdoDlg = true
        document.querySelector('video').srcObject = stream
        this.localMediaStream = stream
      })
      .catch(error => {
        console.error('Webcam access is rejected: ' + error)
      })
    },
    capturePhoto () {
      const canvas = document.createElement('canvas')
      const video = document.querySelector('#cam')
      canvas.width = video.videoWidth
      canvas.height = video.videoHeight
      canvas.getContext('2d').drawImage(video, 0, 0)
      this.avatarURL = canvas.toDataURL('image/png')
      this.vdoDlg = false
      // stop the camera
      var tracks = this.localMediaStream.getTracks()
      tracks.forEach(function (track) {
        track.stop()
      })
      this.localMediaStream.srcObject = null
    },
    closeVdoDlg () {
      this.vdoDlg = false
    },
    cancelChanges () {
      this.$router.go(-1)
    },
    pickAvatar () {
      this.$refs.fileInput.click()
    },
    loadAvatarFromFile (event) {
      const files = event.target.files
      const fileReader = new FileReader()
      fileReader.addEventListener('load', () => {
        this.avatarURL = fileReader.result
      })
      fileReader.readAsDataURL(files[0])
    }
  }
}
</script>
